import React, { Component } from 'react';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, HelpBlock } from 'react-bootstrap'

export class ZoneForm extends Component {

    render() {
        let { zone, zoneTypes, nameInputError, zoneTypeInputError, providerFares, title } = this.props;

        return (
            typeof zone !== 'undefined'
                ?
                <Modal show={this.props.show}>
                    <Modal.Header>
                        <Modal.Title>
                            {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>

                            <FormGroup controlId="formName" validationState={nameInputError}>
                                <ControlLabel>Nome</ControlLabel>
                                <FormControl
                                    type="text"
                                    value={zone.fareZone.name}
                                    placeholder="Introduza o nome"
                                    onChange={(e) => this.props.onChangeValue(e, 'name')}
                                />
                                {nameInputError !== null
                                    ?
                                    <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                    :
                                    null
                                }
                            </FormGroup>

                            <FormGroup controlId="formFare">
                                <ControlLabel>Tarifário</ControlLabel>
                                <FormControl componentClass="select" value={typeof zone.fareZone.fare !== 'undefined' ? zone.fareZone.fare.id : ""} onChange={(e) => this.props.onChangeValue(e, 'fare')}>
                                    <option key={`fare-undefined`}>Sem Tarifário</option>
                                    {
                                        providerFares.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0).map((pFare, idx) =>
                                            <option key={`fare-${idx}`} value={pFare.fare.id}>{pFare.fare.name}</option>
                                        )
                                    }
                                </FormControl>
                            </FormGroup>

                            <FormGroup controlId="formZoneType" validationState={zoneTypeInputError}>
                                <ControlLabel>Tipo de Zona</ControlLabel>
                                <FormControl componentClass="select" value={typeof zone.zoneType !== 'undefined' ? zone.zoneType.id : "Não existem tipos de zona"} onChange={(e) => this.props.onChangeValue(e, 'zoneType')}>
                                    {zoneTypes.length !== 0
                                        ?
                                        zoneTypes.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0).map((zoneType, idx) =>
                                            <option key={`zoneType-${idx}`} value={zoneType.id}>{zoneType.name}</option>
                                        )
                                        :
                                        <option key={`zonetype-undefined`}>Não existem tipos de zona</option>
                                    }
                                </FormControl>
                                {zoneTypeInputError !== null
                                    ?
                                    <HelpBlock> É obrigatório selecionar um tipo de zona. </HelpBlock>
                                    :
                                    null
                                }
                            </FormGroup>

                        </Form>
                        <ButtonToolbar>
                            <Button onClick={this.props.onSave}> GUARDAR ALTERAÇÕES </Button>
                            <Button onClick={this.props.onHide}> CANCELAR </Button>
                        </ButtonToolbar>
                    </Modal.Body>
                </Modal>
                :
                null
        );
    }
}

